import { HttpResult } from "widgets-for-react";
import { updateQueryParams } from "../../../../Shared/utils/browser";
import { SearchResult, searchParam } from "./searchPageState";
import { SearchablePage } from "../../../../Shared/api/elasticsearch/elasticsearchTypes";

export interface SearchApiResponse {
  Count: number
  Results: SearchablePage[]
}

export const fetchSearchResults =
  (query: string, page: number, pageSize: number) => async (): Promise<HttpResult<SearchResult>> => {
    let headers = new Headers()
    headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

    const response = await fetch(`/api/v1/search?query=${query}&page=${page}&pageSize=${pageSize}`, { headers })

    if (response.ok) {
      const body = (await response.json()) as SearchApiResponse

      const results = body.Results.map(r => ({ ...r, ImageUrls: r.Bundle == 'activity' ? { '400x280': r.ImageUrl} : r.ImageUrls }))
      updateQueryParams(searchParam, query) // Update URL Query params
      
      return {
        kind: "result",
        value: {
          totalResults: body.Count,
          results,
          query,
          page
        },
        status: response.status
      }
    }

    return { kind: "failed", status: response.status }
  }